module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAvUlEQVR4AWMYNOA/Mt6PAzPMRMUEDdgHwyQZANVwkIPj/0lNrf8nNTT+H+YXAIqRYMAhYd7/Z1zM/l/y8/l/OdD//1l3q/+HhHiJN+B8gNP/SxE+/2+WZP6/npv8/2K41/8Lgc7EG3A5Mfj/tfTo/9dLk/9fSgj4fy0r9v+VlFDiDTgiK/H/blfF/9tlRf9vlxb8v9tTBRIjLRBPaCj/v56S+P96cvz/E1qqpAQiIgr3gjHhaCSckGhmwPAAAEPa+TwBGsKZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AF.png
// module id = 1069
// module chunks = 0